import { CalendarPlanThemeLink } from '@yandex-int/k-common';
import { findLast } from '@yandex-int/k-common/utils/array';
import { isWithinInterval, isBefore } from 'date-fns';

function getTodayTheme(themes: CalendarPlanThemeLink[]) {
    const today = new Date();
    return themes.find((theme) => {
        const { start_date: startDate, end_date: endDate } = theme.period;

        return isWithinInterval(today, { start: new Date(startDate), end: new Date(endDate) });
    });
}

export function getDefaultTheme(themes: CalendarPlanThemeLink[]) {
    if (!themes.length) {
        return null;
    }

    const today = new Date();

    return (
        getTodayTheme(themes) ||
        findLast(themes, (theme) => {
            const { end_date: endDate } = theme.period;

            return isBefore(new Date(endDate), today);
        }) ||
        themes[0]
    );
}

export function getNextTheme(currentTheme: CalendarPlanThemeLink | null, themes: CalendarPlanThemeLink[]) {
    if (!currentTheme || !themes.length) {
        return null;
    }

    const currentThemeLinkIndex = themes.findIndex((item) => item.theme.id === currentTheme.theme.id);
    return themes[currentThemeLinkIndex + 1] || null;
}

export function getPrevTheme(currentTheme: CalendarPlanThemeLink | null, themes: CalendarPlanThemeLink[]) {
    if (!currentTheme || !themes.length) {
        return null;
    }

    const currentThemeLinkIndex = themes.findIndex((item) => item.theme.id === currentTheme.theme.id);
    return themes[currentThemeLinkIndex - 1] || null;
}
